export default __webpack_public_path__ + "images/referrals-onboarding-step-3.0f7ff97ea87632d61c2a2968a327090c.svg";